export default __webpack_public_path__ + "static/media/pennybun4.d4eb79fe.png";